const financialConsolidatedReports = [
  {
    path: "/financial/consolidated_data",
    name: "FinancialConsolidatedReports",
    meta: {
      auth: true,
      roles: ["Director", "SalesExecutive"],
    },
    component: () => import("@/_backoffice/_financial/components/consolidation/FinancialConsolidatedReports.vue"),
  },
]

export default financialConsolidatedReports
